import React, { useState, useEffect } from 'react';
import './App.css';
import MainTab from './components/MainTab';
import ConfigurationTab from './components/ConfigurationTab';
import TabNavigation from './components/TabNavigation';
import StatusBar from './components/StatusBar';
import RoomPicker from './components/RoomPicker';
import RoomContext from './RoomContext';
import { apiClient } from './api/apiClient';

// Tenant and room come from the URL path: /{tenant}/{room} opens a room directly. /{tenant} resolves the
// tenant's rooms — a single-room tenant opens straight into its one room (short URL), more than one shows
// the picker.
function parsePath() {
  const segments = window.location.pathname.replace(/^\/+|\/+$/g, '').split('/').filter(Boolean);
  return { tenant: segments[0], room: segments[1] };
}

function RoomView({ tenant, room, singleRoom = false }) {
  const [selectedTab, setSelectedTab] = useState(1);
  return (
    <div className="App container">
      <RoomContext.Provider value={{ tenant, room, singleRoom }}>
        <StatusBar />
        <TabNavigation selectedTab={selectedTab} setSelectedTab={setSelectedTab} />
        {selectedTab === 1 ? <MainTab /> : <ConfigurationTab />}
      </RoomContext.Provider>
    </div>
  );
}

function TenantEntry({ tenant }) {
  const [rooms, setRooms] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    apiClient.get(`/api/${tenant}/rooms`)
      .then(r => setRooms(r.data))
      .catch(() => setError(`No se pudieron cargar las habitaciones de "${tenant}".`));
  }, [tenant]);

  if (error) return <div className="alert alert-danger m-3">{error}</div>;
  if (!rooms) return <div className="p-3">Cargando…</div>;
  if (rooms.length === 0) return <div className="alert alert-info m-3">El inquilino "{tenant}" no tiene habitaciones.</div>;
  if (rooms.length === 1) return <RoomView tenant={tenant} room={rooms[0].slug} singleRoom />;
  return <RoomPicker tenant={tenant} rooms={rooms} />;
}

function App() {
  const { tenant, room } = parsePath();

  if (!tenant) {
    return <div className="alert alert-warning m-3">Falta el inquilino en la URL. Usá <code>/{'{tenant}'}</code> o <code>/{'{tenant}'}/{'{room}'}</code>.</div>;
  }

  if (!room) {
    return <TenantEntry tenant={tenant} />;
  }

  return <RoomView tenant={tenant} room={room} />;
}

export default App;
